import React from 'react';
import { useTranslation } from 'react-i18next';
import { TitlesViewIcon, ListViewIcon } from '../IconProvider';
const ListViewFilter = ({ setView, isView }) => {
  const { t } = useTranslation('ownedAssets');
  return (
    <>
      <div className="flex gap-2">
        <button
          onClick={() => setView(1)}
          className={`filter-button
            ${isView === 1 ? 'bg-GreenColor' : 'isview-common-styled'}`}
        >
          {t('tiles')}
          <TitlesViewIcon />
        </button>
        <button
          onClick={() => setView(2)}
          className={`filter-button
            ${isView === 2 ? 'bg-GreenColor' : 'isview-common-styled'}`}
        >
          {t('list')}
          <ListViewIcon />
        </button>
      </div>
    </>
  );
};

export default ListViewFilter;
